module.exports = __webpack_public_path__ + "static/img/hct2.513f960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hct/hct2.jpg
// module id = msNE
// module chunks = 0